<template>
    <div class="preview">
        <modal :show.sync="modals.view_attachment" :hide-footer="true" bodyClasses="preview-modal">
            <h6 slot="header" class="modal-title" v-if="filename">{{filename}}</h6>
            <div class="text-center">
                <img v-if="attachment_type == 'image'" class="img-fluid w-full" :src="url" style="max-width: 1200px; max-height: 600px;">
                <iframe v-else :src="url" class="iframe-preview w-100"></iframe>
            </div>
            <div class="text-center">
                <button class="btn btn-primary mt-4" @click="modals.view_attachment = false">
                    Close
                </button>
            </div>
        </modal>  
    </div>
</template>
<style>
@media only screen and (min-width: 1000px) {
    .preview-modal{
        min-width: 1000px;
    }
}
.preview-modal iframe {
    display: block;       
    background: #000;
    border: none;         
    height: 100vh;       
    width: 100vw;
}
</style>
<script>
    import { Button } from 'element-ui'

    export default {
        components: {
            [Button.name]: Button,
        },
        data() {
            return {
                modals: {
                    view_attachment: false
                },
                filename: '',
                url: '',
                attachment_type:'',
                screen_width:window. innerWidth
            }
        },
        methods: {
            preview(url, filename = null){
                this.modals.view_attachment = true;

                this.filename = filename;
                this.url = url;

                let path = url.toLowerCase();

                if (path.includes(".jpg") || path.includes(".jpeg") || path.includes(".svg") || path.includes(".png")) {
                    this.attachment_type = 'image';
                } else if (path.includes(".pdf")) {
                    this.attachment_type = 'pdf';
                } else {
                    this.attachment_type = 'neither';
                }
            },
            toggleView() {
                this.modals.view_attachment = !this.modals.view_attachment;
            }
        }
    }
</script>